import IntervieweeCard from './IntervieweeCard';

export default IntervieweeCard;
